import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';

const faqs = [
  { q: 'newHomeFaq1Q', a: 'newHomeFaq1A' },
  { q: 'newHomeFaq2Q', a: 'newHomeFaq2A' },
  { q: 'newHomeFaq3Q', a: 'newHomeFaq3A' },
  { q: 'newHomeFaq4Q', a: 'newHomeFaq4A' },
  { q: 'newHomeFaq5Q', a: 'newHomeFaq5A' },
  { q: 'newHomeFaq6Q', a: 'newHomeFaq6A' },
  { q: 'newHomeFaq7Q', a: 'newHomeFaq7A' },
];

const renderFormattedText = (text) => {
  if (!text) return null;
  const parts = [];
  const regex = /\[([^\]]+)\]\(([^)]+)\)/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    const linkText = match[1];
    const linkUrl = match[2];
    parts.push(
      <a
        key={match.index}
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary font-semibold underline hover:text-primary-dark transition-colors"
      >
        {linkText}
      </a>
    );
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts.length > 0 ? parts : text;
};

const HomeFAQs = () => {
  const { language } = useLanguage();
  const t = translations[language] || translations.ar;
  const isAr = language === 'ar';
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      className="py-12 md:py-20 lg:py-24 bg-surface-section border-b border-edge-light"
      dir={isAr ? 'rtl' : 'ltr'}
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center justify-center px-6 py-2 rounded-full bg-badge text-primary-dark text-sm sm:text-base font-bold font-almarai mb-4">
            {t.newHomeFaqSubtitle}
          </span>
          <h2 className="font-ibm text-[26px] md:text-[34px] font-bold text-heading">
            {t.newHomeFaqTitle}
          </h2>
        </div>

        {/* FAQ List */}
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl border border-edge-card overflow-hidden transition-colors shadow-sm"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="w-full p-6 text-start flex justify-between items-center gap-4"
                >
                  <span className="font-ibm text-lg font-bold text-heading">
                    {t[faq.q]}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-heading transition-transform duration-200 flex-shrink-0 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 pt-0 font-almarai text-[15px] text-body-muted leading-relaxed border-t border-edge-card/50 mt-1 pt-4">
                    {renderFormattedText(t[faq.a])}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeFAQs;
